<template>
  <!-- 月次検査レンタル器出荷サマリー -->
  <div id="ShppingMonthlySummary">
    <div id="container">
      <div class="labelTitle lable">月次検査レンタル器出荷サマリー</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable" style="width:300px;">
          <tr>
            <th>年</th>
            <td>
              <select v-model="selectedYear">
                <option v-for="year in optionYears" :key="year" :value="year">{{year}}年</option>
              </select>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div v-if="data.length > 0">
        <section>
          <div class="labelTitle lable">{{searchedYear}}年サマリー</div>
          <div>
            <div class="button-area">
              <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('summaryTable')">クリップボードにコピー</b-button>
            </div>
            <div>
              <table id="summaryTable">
                <tr>
                  <td>機種</td>
                  <td>1月</td>
                  <td>2月</td>
                  <td>3月</td>
                  <td>4月</td>
                  <td>5月</td>
                  <td>6月</td>
                  <td>7月</td>
                  <td>8月</td>
                  <td>9月</td>
                  <td>10月</td>
                  <td>11月</td>
                  <td>12月</td>
                  <td>総件数</td>
                  <td>月平均</td>
                  <td>レンタル台数</td>
                  <td>回転率</td>
                  <td>リースアップ予定</td>
                </tr>
                <tr v-for="(item ,index) of data" :key="index">
                  <td>{{item.modelName}}<!--機種--></td>
                  <td>{{item.m1}}<!--1月--></td>
                  <td>{{item.m2}}<!--2月--></td>
                  <td>{{item.m3}}<!--3月--></td>
                  <td>{{item.m4}}<!--4月--></td>
                  <td>{{item.m5}}<!--5月--></td>
                  <td>{{item.m6}}<!--6月--></td>
                  <td>{{item.m7}}<!--7月--></td>
                  <td>{{item.m8}}<!--8月--></td>
                  <td>{{item.m9}}<!--9月--></td>
                  <td>{{item.m10}}<!--10月--></td>
                  <td>{{item.m11}}<!--11月--></td>
                  <td>{{item.m12}}<!--12月--></td>
                  <td>{{item.shipmentTotal}}<!--総件数--></td>
                  <td>{{item.shipmentAvg}}<!--月平均--></td>
                  <td>{{item.rental}}<!--レンタル台数--></td>
                  <td>{{item.rate}}<!--回転率--></td>
                  <td>{{item.totalLeaseupCount}}<!--リースアップ予定--></td>
                </tr>
              </table>
            </div>
          </div>
        </section>
        <div class="button-area">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShppingMonthlySummary",
  methods: {
    doSearch: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalSpreadsheet.getSpreadsheetRentalShipmentsSummaryPOST({
            body: {
              year: _this.selectedYear
            }
          });
        },
        function(result){
          _this.searchedYear = _this.selectedYear
          _this.data = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      navigator.clipboard.writeText(btable.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    back: function() {
      this.$router.go(-1);
    }
  },
  data() {
    var optionYears = [];
    var thisYear = new Date().getFullYear();
    for(var year = 2021; year <= thisYear; year++){
      optionYears.push(year)
    }

    return {
      optionYears: optionYears,
      selectedYear: thisYear,
      searchedYear: thisYear,
      data:[]
    };
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>
#summaryTable {
    font-size: 100% !important;
}
#summaryTable tr,
#summaryTable th,
#summaryTable td{
    border: black 1px solid;
    text-align: center;
}


</style>


// WEBPACK FOOTER //
// src/components/mock/philips/spreadSheet/ShppingMonthlySummary.vue